import { Theme } from '@mui/material';
import { WbGrid } from '@workbench/react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme: Theme) => ({
    mainContainerOidc: {
        padding: theme.spacing(7),
        backgroundColor: theme.palette.common.white,
        minHeight: '100%',
        minWidth: '100%',
    },
}));

const OidcLogin = () => {
    const navigate = useNavigate();
    const { classes } = useStyles();

    useEffect(() => {
        navigate('/');
    }, [navigate]);

    return <WbGrid className={classes.mainContainerOidc}>OIDC Login</WbGrid>;
};

export default OidcLogin;
